var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanySettingsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0505 7.24219H3.5C2.11929 7.24219 1 6.1229 1 4.74219C1 3.36148 2.11929 2.24219 3.5 2.24219H13.0505M6.94949 18.2422H16.5C17.8807 18.2422 19 17.1229 19 15.7422C19 14.3615 17.8807 13.2422 16.5 13.2422H6.94949M1 15.7422C1 17.6752 2.567 19.2422 4.5 19.2422C6.433 19.2422 8 17.6752 8 15.7422C8 13.8092 6.433 12.2422 4.5 12.2422C2.567 12.2422 1 13.8092 1 15.7422ZM19 4.74219C19 6.67518 17.433 8.24219 15.5 8.24219C13.567 8.24219 12 6.67518 12 4.74219C12 2.80919 13.567 1.24219 15.5 1.24219C17.433 1.24219 19 2.80919 19 4.74219Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySettingsWhite);
export default __webpack_public_path__ + "static/media/company-settings-white.9d02c394e4e6517e920104a37448ad01.svg";
export { ForwardRef as ReactComponent };